export const initialState = {
    isDarkMode: false,
    mainLayout: 'app',
    theme: 'light',
    menu: 'horizontal',
    layout: 'full',
    rtlClass: 'ltr',
    animation: '',
    navbar: 'navbar-sticky',
    locale: 'en',
    sidebar: false,
    languageList: [
        { code: 'zh', name: 'Chinese' },
        { code: 'da', name: 'Danish' },
        { code: 'en', name: 'English' },
        { code: 'fr', name: 'French' },
        { code: 'de', name: 'German' },
        { code: 'el', name: 'Greek' },
        { code: 'hu', name: 'Hungarian' },
        { code: 'it', name: 'Italian' },
        { code: 'ja', name: 'Japanese' },
        { code: 'pl', name: 'Polish' },
        { code: 'pt', name: 'Portuguese' },
        { code: 'ru', name: 'Russian' },
        { code: 'es', name: 'Spanish' },
        { code: 'sv', name: 'Swedish' },
        { code: 'tr', name: 'Turkish' },
        { code: 'ae', name: 'Arabic' },
    ],
    isShowMainLoader: false,
    semidark: false,
};

export function indexReducer(state = initialState, action: any) {
    const { type } = action;
    let payload = action.payload;
  
    switch (type) {
  
      case 'toggleDirection':
        localStorage.setItem('direction', payload);
        document.querySelector('html')
          ?.setAttribute('dir', payload || 'ltr');
  
        return {
          ...state,
          direction: payload
        };
  
      case 'toggleMainLoader':
        return {
          ...state,
          isShowMainLoader: payload
        };
  
      case 'setMainLayout':
        return {
          ...state,
          mainLayout: payload
        };
  
      case 'toggleTheme':
        return handleTheme(state, payload);
  
      case 'toggleMenu':
        payload = payload || state.menu;
        localStorage.setItem('menu', payload);
  
        return {
          ...state,
          sidebar: false,
          menu: payload
        };
  
      case 'toggleLayout':
        payload = payload || state.layout;
        localStorage.setItem('layout', payload);
  
        return {
          ...state,
          layout: payload
        };
  
      case 'toggleRTL':
        payload = payload || state.rtlClass;
  
        localStorage.setItem('rtlClass', payload);
  
        document.querySelector('html')
          ?.setAttribute('dir', payload || 'ltr');
  
        return {
          ...state,
          rtlClass: payload
        };
  
      case 'toggleAnimation':
        return handleAnimation(state, payload);
  
      case 'toggleNavbar':
        payload = payload || state.navbar;
  
        localStorage.setItem('navbar', payload);
  
        return {
          ...state,
          navbar: payload
        };
  
      case 'toggleSemidark':
        payload = payload || false;
  
        localStorage.setItem('semidark', payload);
  
        return {
          ...state,
          semidark: payload
        };
  
      case 'toggleLocale':
        payload = payload || state.locale;
  
        localStorage.setItem('i18n_locale', payload);
  
        return {
          ...state,
          locale: payload
        };
  
      case 'toggleSidebar':
        return {
          ...state,
          sidebar: !state.sidebar
        };
  
      default:
        return state;
    }
  }

  function handleTheme(state: any, payload: any) {

    payload = payload || state.theme;
  
    localStorage.setItem('theme', payload);
  
    const isDarkMode = getDarkMode(payload);
  
    document.querySelector('body')
      ?.classList.toggle('dark', isDarkMode);
  
    return {
      ...state,
      theme: payload,
      isDarkMode
    };
  }

  function getDarkMode(theme: string): boolean {

    if (theme === 'light') {
      return false;
    }
  
    if (theme === 'dark') {
      return true;
    }
  
    return globalThis.matchMedia?.(
      '(prefers-color-scheme: dark)'
    ).matches ?? false;
  }

  function handleAnimation(state: any, payload: any) {

    payload = payload?.trim();
  
    localStorage.setItem('animation', payload);
  
    if (payload) {
      const element: any =
        document.querySelector('.animation');
  
      element?.classList.add(
        'animate__animated',
         'payload'
      )
    }
  
    return {
      ...state,
      animation: payload
    };
  }